export const LOAD_PROFILE = 'Dyzio/Profile/LOAD_PROFILE';



/** WEBPACK FOOTER **
 ** ./src/containers/user-profile/constants.js
 **/